export function insert(str: string, substr: string, pos: number) {
  const array = str.split('');
  array.splice(pos, 0, substr);
  return array.join('');
}

export function decodeValueChars(str: string): string {
  try {
    return decodeURIComponent(str);
  } catch (e) {
    return str;
  }
}

const UUID_REGEXP =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuidString(value: string): boolean {
  return UUID_REGEXP.test(value.trim());
}
